import { useFlags } from "flagsmith/react";
import { useUser } from "./useUser";

interface FileManagerAccess {
	isFileManagerDisabled: boolean;
	isFileManagerEnabled: boolean;
}

export function useFileManagerAccess(): FileManagerAccess {
	const flags = useFlags(["disable_file_manager"]);
	const { user } = useUser();

	const flag = flags?.disable_file_manager;

	// If flag doesn't exist or is not enabled, file manager is enabled for everyone
	if (!flag || !flag.enabled) {
		return {
			isFileManagerDisabled: false,
			isFileManagerEnabled: true,
		};
	}

	// Flag is enabled, so file manager is disabled by default
	// Check if user is in the exception list (users who CAN still access file manager)
	if (!flag.value || !user?.id) {
		return {
			isFileManagerDisabled: true,
			isFileManagerEnabled: false,
		};
	}

	// Parse comma-separated list of user IDs who are exempt from the disable
	const exemptUserIds = String(flag.value)
		.split(",")
		.map((id) => id.trim())
		.filter((id) => id !== "")
		.map((id) => parseInt(id, 10))
		.filter((id) => !isNaN(id));

	// Check if current user is exempt from the disable
	const isUserExempt = exemptUserIds.includes(user.id);

	return {
		isFileManagerDisabled: !isUserExempt,
		isFileManagerEnabled: isUserExempt,
	};
}
